export const styles = {
	field: {
		marginBottom: 1,
		width: 400,
		display: 'flex'
	},
	card: {
		display: 'inline-flex',
		flexDirection: 'column',
		marginBottom: 4
	},
	content: {
		paddingTop: 0
	},
	centered: {
		display: 'inline-flex',
		minWidth: 430,
		minHeight: 250,
		justifyContent: 'center',
		alignItems: 'center'
	},
	error: {
		color: 'red',
		marginTop: 1,
		marginLeft: 1
	}
};
